import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ZonaExtendidaPesoPrecioEdit } from "./edit";
const EditModal = ZonaExtendidaPesoPrecioEdit;

type Entity = models.ZonaExtendidaPesoPrecio;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Peso vol. hasta (kg)", cell: x => ({ data: x.PesoHasta }) },
        { title: "Precio", cell: x => ({ data: x.Precio, view: kea.formatCurrency }) },
    ];
}

/**
* Listado de ZonaExtendidaPesoPrecio
*/
class PesoPrecioListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.PesoHasta + "");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        const items = orderBy(this.props.value, x => x.PesoHasta);

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="alert alert-warning">
                            En los limites de peso, se considera el valor indicado como peso máximo, es decir si el limite es de 20kg entrará en este rango todos los valores mayores al limite anterior y menor o igual a 20kg
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Peso precios</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={items} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const PesoPrecioList = kea.mapProps(componentToRx(PesoPrecioListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifasprecio/edit/components/pesosprecios/list.tsx